import { inject, Service } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { PlatformService } from '@thiememeulenhoff/ng-api-gateway';
import { UserInterface } from '@thiememeulenhoff/types';

@Service()
export class UserService {
  readonly #platformService = inject(PlatformService);

  readonly #userSubject = new BehaviorSubject<UserInterface | undefined>(
    undefined,
  );

  readonly user$ = this.#userSubject.asObservable();

  get user() {
    return this.#userSubject.value;
  }

  setUser = (user: UserInterface | undefined) => {
    this.#userSubject.next(user);
  };

  fetchUser(renew = false) {
    return this.#platformService
      .me(renew)
      .pipe(tap((user) => this.setUser(user)));
  }
}
